/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TemplateContentDto
 */
export interface TemplateContentDto {
    /**
     * 
     * @type {string}
     * @memberof TemplateContentDto
     */
    templateContent: string;
}

export function TemplateContentDtoFromJSON(json: any): TemplateContentDto {
    return TemplateContentDtoFromJSONTyped(json, false);
}

export function TemplateContentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateContentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'templateContent': json['templateContent'],
    };
}

export function TemplateContentDtoToJSON(value?: TemplateContentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'templateContent': value.templateContent,
    };
}

